import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledWrapper = styled.div`
  width: 100%;
  height: ${rem('332px')};
  ${mediaqueries.greaterThan('mobile')`
    height: ${rem('520px')};
  `};
`;

const StyledRecurs = styled.div`
  height: 100vh;
  position: relative;
  ${mediaqueries.greaterThan('desktop')`
    width: 360px;
    margin: 0 auto;
  `};
`;

const StyleEventTitle = styled.p`
  color: ${props => props.theme.colors.dark};
  display: inline;
  font-size: ${rem('12px')};
  font-weight: normal;
  margin: 0;
  max-width: 100%;
  overflow: hidden;
  padding: 10px 0 0 10px;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;

  :before {
    background-color: ${props => props.theme.colors.activeBlue};
    border: ${rem('2px')} solid ${props => props.theme.colors.success};
    border-radius: 50%;
    content: '';
    height: 6px;
    left: 0;
    position: absolute;
    top: 10px;
    width: 6px;
  }

  ${mediaqueries.greaterThan('mobile')`
    display: block;
    padding: 0 0 0 10px;
  `};
`;
const StyleEventText = styled.span`
  display: none;

  ${mediaqueries.greaterThan('mobile')`
    display: inline-block;
  `};
`;

export { StyleEventTitle, StyleEventText, StyledWrapper, StyledRecurs };
